import { Component } from '@angular/core';
import { IbexIconList } from '@ibexfusion/ibex-icon';
import { PageAction } from '../../components/page-actions/page-actions.component';

@Component({
    selector: 'app-ibexicon',
    templateUrl: './ibexicon.component.html',
    styleUrls: ['./ibexicon.component.scss'],
    standalone: false
})

export class IbexiconComponent {

  public iconList = [];
  public defIconList = [];
  public title = 'Ibexicon';
  public pageActions: PageAction[];
  public iconType = 'normal';
  public searchValue = '';

  constructor() {
    const list = new IbexIconList();
    this.defIconList = list.getList();
    this.updateList();
  }

  changeType(type) {
    this.iconType = type;
    this.updateList();
  }

  onSearchChange(search) {
    this.updateList();
  }

  updateList() {
    if (this.iconType === 'normal') {
      this.iconList = this.defIconList.filter(el => el.indexOf('-blank') === -1 && el.indexOf('-contrast') === -1);
    } else if (this.iconType === 'contrast') {
      this.iconList = this.defIconList.filter(el => el.indexOf('-contrast') !== -1);
    } else if (this.iconType === 'blank') {
      this.iconList = this.defIconList.filter(el => el.indexOf('-blank') !== -1);
    }
    if (this.searchValue) {
      this.iconList = this.iconList.filter(el => el.indexOf(this.searchValue) !== -1);
    }
  }
}
